import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 5.54637C0 3.03134 2.04752 1 4.563 1H23.437C25.9525 1 28 3.03134 28 5.54637V18.9315C28 21.4465 25.9525 23.4779 23.437 23.4779H15.0666L8.20437 26.8927C7.88683 27.0507 7.51013 27.0333 7.20858 26.8465C6.90704 26.6598 6.72355 26.3304 6.72355 25.9758V23.4779H4.563C2.04764 23.4779 0 21.4473 0 18.9315V5.54637ZM4.563 3.04848C3.17028 3.04848 2.04878 4.17141 2.04878 5.54637V18.9315C2.04878 20.307 3.17016 21.4294 4.563 21.4294H7.74794C8.3137 21.4294 8.77233 21.888 8.77233 22.4536V24.3219L14.3694 21.5367C14.5112 21.4661 14.6674 21.4294 14.8258 21.4294H23.437C24.8297 21.4294 25.9512 20.3065 25.9512 18.9315V5.54637C25.9512 4.17141 24.8297 3.04848 23.437 3.04848H4.563Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }